import { Abstrap } from '../../../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class TableCellTitle extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-table__title',
            className,
        ];
    }

}

TableCellTitle.propTypes = propTypes;

TableCellTitle.defaultProps = defaultProps;

export default TableCellTitle;
